import reducer from './reducers';
import * as actions from './actions';
import sagas from './sagas'; // sagas
import * as types from './types';

export const appActions = actions;
export const appReducer = reducer;
export const appSagas = sagas;
export const appTypes = types;
